import { useOrgaRoles } from "@/composition/user/use-orga-roles";

const ALLOWED_ROUTES_NAMES = ["dashboard", "login", "logout"];

const isDashboardViewer = () => {
  const { isDashboardViewer } = useOrgaRoles();
  return isDashboardViewer.value;
};

export const createDashboardViewerMiddleware = (router) => {
  const init = () => {
    router.beforeEach((to, from, next) => {
      if (!isDashboardViewer()) {
        next();
        return;
      }

      if (ALLOWED_ROUTES_NAMES.includes(to.name)) {
        next();
        return;
      }

      if (from.name !== "dashboard") {
        next({ name: "dashboard" });
        return;
      } 

      // ignore all other routes
      next(false);
    })

    return router;
  }

  return init();
};
